<template>
  <div class="container mt-3 profile-container">
    <b-card no-body class="shadow-sm border-0">
      <b-tabs card pills vertical v-model="tabIndex" nav-wrapper-class="col-md-3 border-right bg-light" content-class="col-md-9 p-4">
        <!-- 1. 个人资料 Tab -->
        <b-tab title="个人资料">
          <div class="tab-header mb-4">
            <h4 class="font-weight-bold">个人资料</h4>
            <p class="text-muted small">管理您的基本账号信息与安全设置</p>
          </div>
          
          <div class="profile-form">
            <b-form-group label="用户昵称" label-for="nick-input" label-cols-sm="3">
              <b-form-input id="nick-input" v-model="user_nick" disabled></b-form-input>
            </b-form-group>
            
            <b-form-group label="原密码" label-for="old-pass" label-cols-sm="3">
              <b-form-input id="old-pass" type="password" v-model="old_password" placeholder="修改密码请先输入原密码"></b-form-input>
            </b-form-group>
            
            <b-form-group label="新密码" label-for="new-pass1" label-cols-sm="3">
              <b-form-input id="new-pass1" type="password" v-model="new_password1"></b-form-input>
            </b-form-group>
            
            <b-form-group label="确认新密码" label-for="new-pass2" label-cols-sm="3">
              <b-form-input id="new-pass2" type="password" v-model="new_password2"></b-form-input>
            </b-form-group>
            
            <div class="text-right mt-3">
              <b-button variant="primary" @click="save" class="px-4">修改密码</b-button>
            </div>
          </div>

          <hr class="my-4">
          
          <div class="binding-section">
            <h5 class="mb-3">账号绑定</h5>
            <div class="mb-3 d-flex align-items-center justify-content-between p-3 bg-white border rounded">
              <div class="d-flex align-items-center">
                <b-icon icon="wechat" variant="success" class="h4 mb-0 mr-3"></b-icon>
                <div>
                  <div class="font-weight-bold">微信账号</div>
                  <div class="small text-muted" v-if="wx_name">{{ wx_name }} (已绑定)</div>
                  <div class="small text-muted" v-else>未绑定微信</div>
                </div>
              </div>
              <div>
                <b-button v-if="!wx_name" variant="outline-success" size="sm" @click="showBindModal">立即绑定</b-button>
                <b-badge v-else variant="success" pill>已绑定</b-badge>
              </div>
            </div>
            
            <div class="mb-3 d-flex align-items-center justify-content-between p-3 bg-white border rounded">
              <div class="d-flex align-items-center">
                <b-icon icon="envelope" variant="primary" class="h4 mb-0 mr-3"></b-icon>
                <div>
                  <div class="font-weight-bold">电子邮箱</div>
                  <div class="small text-muted" v-if="email">{{ email }} (已绑定)</div>
                  <div class="small text-muted" v-else>未绑定邮箱</div>
                </div>
              </div>
              <div>
                <b-button v-if="!email" variant="outline-primary" size="sm" @click="showEmailBindModal">立即绑定</b-button>
                <b-badge v-else variant="primary" pill>已绑定</b-badge>
              </div>
            </div>
          </div>
        </b-tab>

        <!-- 2. 我的订阅 Tab -->
        <b-tab title="我的订阅">
          <div class="tab-header mb-4 d-flex justify-content-between align-items-end">
            <div>
              <h4 class="font-weight-bold">我的订阅</h4>
              <p class="text-muted small mb-0">查看已开通的高级功能与接口权益</p>
            </div>
            <b-button variant="primary" size="sm" to="/subscription" class="mb-1">
              <b-icon icon="cart-plus" class="mr-1"></b-icon>续费 / 订阅
            </b-button>
          </div>

          <div v-if="featureSubs.length === 0 && sdkSubs.length === 0" class="text-center py-5 border rounded bg-white">
            <b-icon icon="calendar-x" font-scale="4" class="text-muted mb-3"></b-icon>
            <p class="text-muted">暂无有效订阅</p>
            <b-button variant="primary" to="/subscription">前往订阅中心</b-button>
          </div>
          
          <div v-else>
            <!-- 网站功能模块订阅 -->
            <div v-if="featureSubs.length > 0" class="mb-4">
              <h6 class="font-weight-bold text-dark border-left border-primary pl-2 mb-3">网站高级功能</h6>
              <div class="row">
                <div v-for="sub in featureSubs" :key="sub.id" class="col-12 mb-3">
                  <div class="p-3 bg-white border rounded shadow-sm hover-shadow transition-all d-flex justify-content-between align-items-center">
                    <div>
                      <div class="h6 font-weight-bold mb-1 text-primary">{{ sub.name }}</div>
                      <div class="small text-muted">
                        <b-icon icon="clock" class="mr-1"></b-icon>
                        到期时间：{{ sub.end }}
                      </div>
                    </div>
                    <div class="text-right d-flex flex-column align-items-end">
                      <b-badge class="px-3 py-2 mb-2" style="background-color: #e6a23c; color: white;">服务中</b-badge>
                      <b-button variant="outline-primary" size="sm" :to="`/subscription?module=${sub.code}`">
                        <b-icon icon="arrow-repeat" class="mr-1"></b-icon>续费
                      </b-button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            
            <!-- SDK 订阅 -->
            <div v-if="sdkSubs.length > 0">
              <h6 class="font-weight-bold text-dark border-left border-info pl-2 mb-3">数据接口服务 (SDK)</h6>
              <div class="row">
                <div v-for="sub in sdkSubs" :key="sub.id" class="col-12 mb-3">
                   <div class="p-3 bg-white border rounded shadow-sm d-flex justify-content-between align-items-center">
                    <div>
                      <div class="h6 font-weight-bold mb-1">{{ sub.name }}</div>
                      <div class="small text-muted">
                        <b-icon icon="calendar-check" class="mr-1"></b-icon>
                        有效期至：{{ sub.end }}
                      </div>
                    </div>
                    <b-badge variant="info" class="px-3 py-2">已授权</b-badge>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </b-tab>

        <!-- 3. 接口 Token Tab -->
        <b-tab title="接口 Token">
          <div class="tab-header mb-4">
            <div class="d-flex align-items-center">
              <h4 class="font-weight-bold mb-0">接口 Token</h4>
              <WxShare 
                class="ml-3" 
                title="自在量化 zzshare SDK - 开启你的智能量化交易"
                desc="提供专业且免费的 A股量化金融数据接口 zzshare SDK，包含日线行情、实时快照与情绪指标，用 Python 开启快速调用！"
                :link="shareLink"
              />
            </div>
            <p class="text-muted small mb-0 mt-2">用于 zzshare SDK 的鉴权凭证</p>
          </div>

          <div class="token-main p-4 border rounded bg-white shadow-sm">
            <div class="d-flex justify-content-between align-items-center mb-3">
              <div>
                <span class="text-dark font-weight-bold">SDK 访问密钥 (Secret Key)</span>
                <div class="text-muted x-small mt-1">请妥善保管，切勿泄露。参考文档：<a href="https://github.com/zzquant/zzshare" target="_blank">zzshare SDK</a></div>
              </div>
              <div v-if="userPoints !== null" class="text-right">
                <div class="small text-muted mb-1">当前可用积分</div>
                <b-badge variant="info" style="font-size: 1.1rem;" class="px-3 py-1">{{ userPoints }}</b-badge>
              </div>
            </div>

            <!-- Token 显示行 -->
            <div class="d-flex align-items-center bg-light p-2 rounded border mb-4">
              <b-form-input 
                :value="apiToken" 
                :type="tokenVisible ? 'text' : 'password'"
                readonly 
                class="token-input flex-grow-1 mr-2 border-0 bg-transparent h5 mb-0 text-primary font-weight-bold"
                style="box-shadow: none;"
              ></b-form-input>
              <div class="btn-group">
                <b-button variant="outline-secondary" size="sm" @click="tokenVisible = !tokenVisible" title="切换可见性">
                   <b-icon :icon="tokenVisible ? 'eye-slash' : 'eye'"></b-icon>
                </b-button>
                <b-button variant="outline-primary" size="sm" @click="copyToken" title="复制">
                   <b-icon :icon="tokenCopied ? 'check' : 'clipboard'"></b-icon>
                </b-button>
                <b-button variant="outline-danger" size="sm" @click="showRefreshConfirm = true" title="重置 Token">
                   <b-icon icon="arrow-clockwise"></b-icon>
                </b-button>
              </div>
            </div>

            <!-- 使用示例 -->
            <div class="usage-example mb-4">
              <div class="small font-weight-bold text-muted mb-2">Python 快速调用示例：</div>
              <div class="bg-dark text-light p-3 rounded position-relative">
                <code class="text-light">api = DataApi(token='{{ tokenVisible ? apiToken : "your_token" }}')</code>
                <b-button variant="link" size="sm" class="position-absolute text-light" style="top:5px; right:5px;" @click="copyText(`api = DataApi(token='${apiToken}')`)">
                  <b-icon icon="clipboard"></b-icon>
                </b-button>
              </div>
            </div>

            <!-- 限额说明 -->
            <div v-if="processedLimits.length > 0">
              <div class="small font-weight-bold text-muted mb-3"><b-icon icon="shield-lock-fill" class="mr-1 text-primary"></b-icon> 接口频率限额权益明细 (API Rate Limits)：</div>
              <div class="table-responsive">
                <table class="table table-hover border mb-0 custom-limits-table">
                  <thead class="bg-light">
                    <tr>
                      <th>接口 (zzshare)</th>
                      <th class="text-center" style="width: 160px;">无token</th>
                      <th class="text-center" style="width: 160px;">有token</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="lim in processedLimits" :key="lim.key">
                      <td>
                        <div class="font-weight-bold mb-1">
                          <a href="https://github.com/zzquant/zzshare" target="_blank" class="api-link">
                            <code class="text-primary font-weight-bold h6">{{ lim.name }}()</code>
                          </a>
                        </div>
                        <span class="badge badge-info-soft font-weight-normal small">{{ lim.chineseName }}</span>
                      </td>
                      <td class="text-center font-weight-bold text-warning align-middle">{{ lim.ipLimit }}</td>
                      <td class="text-center font-weight-bold text-danger align-middle">{{ lim.tokenLimit }}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div class="text-right mt-3 small text-muted">
                更多请参考文档：<a href="https://github.com/zzquant/zzshare" target="_blank" class="font-weight-bold text-primary">zzshare SDK</a>
              </div>
            </div>
          </div>
        </b-tab>

        <!-- 4. 我的分享 Tab -->
        <b-tab title="我的分享">
          <div class="tab-header mb-4">
            <h4 class="font-weight-bold">我的分享</h4>
            <p class="text-muted small">邀请好友注册，获取积分抵扣订阅费</p>
          </div>

          <div class="row">
            <div class="col-md-6 mb-3">
              <div class="p-4 bg-white border rounded shadow-sm text-center">
                <div class="text-muted small mb-2">我的总积分</div>
                <div class="h2 text-success font-weight-bold">{{ referralData.total_points || 0 }}</div>
                <div class="small text-muted mt-2">1 积分 = 1 元抵扣金额</div>
              </div>
            </div>
            <div class="col-md-6 mb-3">
              <div class="p-4 bg-white border rounded shadow-sm text-center">
                <div class="text-muted small mb-2">今日新增积分</div>
                <div class="h2 text-primary font-weight-bold">{{ referralData.points_today || 0 }}</div>
                <div class="small text-muted mt-2">今日成功邀请的人数对应积分</div>
              </div>
            </div>
          </div>

          <div class="mt-4 p-4 bg-white border rounded shadow-sm">
            <h6 class="font-weight-bold text-dark border-left border-primary pl-2 mb-3">邀请方式</h6>
            <p class="text-muted small mb-3">当您的朋友使用您的专属链接或邀请码注册成功后，您将获得 <strong class="text-danger">{{ referralData.reward_points || 10 }}</strong> 个分享积分。</p>
            
            <b-form-group label="您的专属邀请码" label-for="invite-code-input">
              <div class="d-flex align-items-center">
                <b-form-input 
                  id="invite-code-input" 
                  :value="referralData.invite_code" 
                  readonly 
                  class="font-weight-bold text-primary mr-2"
                  style="max-width: 200px;"
                ></b-form-input>
                <b-button variant="outline-primary" size="sm" @click="copyText(referralData.invite_code)">复制邀请码</b-button>
              </div>
            </b-form-group>
            
            <b-form-group label="您的专属邀请链接" label-for="invite-link-input" class="mt-3">
              <div class="d-flex align-items-center">
                <b-form-input 
                  id="invite-link-input" 
                  :value="inviteLink" 
                  readonly 
                  class="mr-2"
                ></b-form-input>
                <b-button variant="outline-primary" size="sm" @click="copyText(inviteLink)">复制邀请链接</b-button>
              </div>
            </b-form-group>
            
            <div class="mt-3 text-center p-3 bg-light border rounded">
               <div id="invite-qrcode" class="mx-auto" style="width: 150px; height: 150px;"></div>
               <div class="small text-muted mt-2">扫一扫注册</div>
            </div>
          </div>

          <!-- 邀请明细列表 -->
          <div class="mt-4">
            <h6 class="font-weight-bold text-dark border-left border-success pl-2 mb-3">邀请明细</h6>
            <div class="table-responsive bg-white border rounded shadow-sm">
              <table class="table table-hover mb-0">
                <thead class="bg-light">
                  <tr>
                    <th>被邀请人昵称</th>
                    <th class="text-right">加入时间</th>
                  </tr>
                </thead>
                <tbody v-if="referralList.length > 0">
                  <tr v-for="(item, index) in referralList" :key="index">
                    <td class="font-weight-bold text-dark">
                      {{ item.nickname }}
                      <b-badge v-if="item.status === 0" variant="warning" class="ml-2">审核中</b-badge>
                      <b-badge v-else-if="item.status === 2" variant="danger" class="ml-2">未通过</b-badge>
                      <b-badge v-else variant="success" class="ml-2">已通过</b-badge>
                    </td>
                    <td class="text-right text-muted small">{{ item.created_at }}</td>
                  </tr>
                </tbody>
                <tbody v-else>
                  <tr>
                    <td colspan="2" class="text-center py-4 text-muted">暂无邀请成功的记录</td>
                  </tr>
                </tbody>
              </table>
            </div>

            <!-- 分页控制 -->
            <div v-if="referralTotal > referralPageSize" class="mt-3 d-flex justify-content-between align-items-center">
              <div class="text-muted small">共 {{ referralTotal }} 条记录</div>
              <div class="d-flex align-items-center">
                <b-button size="sm" variant="outline-secondary" :disabled="referralPage <= 1" @click="changeReferralPage(referralPage - 1)">
                  <b-icon icon="chevron-left"></b-icon>
                </b-button>
                <span class="mx-3 small">第 {{ referralPage }} 页</span>
                <b-button size="sm" variant="outline-secondary" :disabled="referralPage * referralPageSize >= referralTotal" @click="changeReferralPage(referralPage + 1)">
                  <b-icon icon="chevron-right"></b-icon>
                </b-button>
              </div>
            </div>
          </div>
        </b-tab>

        <!-- 5. 用量报表 Tab -->
        <b-tab title="用量报表">
          <UserApiUsageReport />
        </b-tab>
      </b-tabs>
    </b-card>


    <!-- 微信绑定弹窗 -->
    <b-modal v-model="showWxModal" title="绑定微信" hide-footer centered @shown="onModalShown">
      <div class="text-center p-3">
        <div id="wx-qrcode" class="mx-auto" style="min-height: 300px; width: 300px;"></div>
        <div class="mt-3 text-muted">
          <b-icon icon="info-circle" class="mr-1"></b-icon>请使用微信扫描上方二维码完成绑定
        </div>
      </div>
    </b-modal>

    <!-- 邮箱绑定弹窗 -->
    <b-modal v-model="showEmailModal" title="绑定邮箱" @ok="bindEmail" ok-title="确认绑定" cancel-title="取消" centered>
        <b-form-group label="邮箱地址" label-for="email-input">
            <b-form-input id="email-input" v-model="inputEmail" type="email" placeholder="请输入您的常用邮箱" required></b-form-input>
        </b-form-group>
        <b-form-group label="验证码" label-for="code-input">
            <div class="d-flex">
                <b-form-input id="code-input" v-model="verificationCode" placeholder="6位验证码" required></b-form-input>
                <b-button variant="primary" class="ml-2" style="min-width: 120px;" :disabled="countdown > 0" @click="sendVerificationCode">
                    {{ countdown > 0 ? `${countdown}s` : '发送验证码' }}
                </b-button>
            </div>
        </b-form-group>
    </b-modal>

    <!-- Token 刷新确认弹窗 -->
    <b-modal v-model="showRefreshConfirm" title="安全确认" ok-title="确认重置" ok-variant="danger" cancel-title="点错了" centered @ok="doRefreshToken">
      <div class="text-center p-2">
        <b-icon icon="exclamation-triangle" variant="danger" font-scale="3" class="mb-3"></b-icon>
        <h5 class="text-danger font-weight-bold">确定要重置 Token 吗？</h5>
        <p class="text-muted small mt-2 text-left">重置后旧 Token 会立即失效，您的所有自动交易脚本或数据抓取程序需要更新 Token 才能继续运行。</p>
      </div>
    </b-modal>

    <!-- 全局提示 -->
    <b-toast v-if="msg" visible static no-auto-hide variant="info" style="position: fixed; bottom: 20px; right: 20px; z-index: 1000;">
       {{ msg }}
    </b-toast>
  </div>
</template>

<script>
import { request_zzquant } from 'network/request.js'
import QRCode from 'qrcode'
import WxShare from '@/components/share/WxShare.vue'
import UserApiUsageReport from '@/components/user/UserApiUsageReport.vue'

export default {
  components: {
    WxShare,
    UserApiUsageReport
  },

  data(){ 
    return { 
      user_nick:'', 
      old_password:'', 
      new_password1:'', 
      new_password2:'', 
      avatarUrl:'', 
      file:null, 
      msg:'',
      // WeChat binding data
      wx_name: '',
      wx_avatar: '',
      showWxModal: false,
      wechatQrInited: false,
      // Email binding data
      email: '',
      showEmailModal: false,
      inputEmail: '',
      verificationCode: '',
      countdown: 0,
      timer: null,
      // Token 管理
      apiToken: '',
      tokenVisible: false,
      tokenCopied: false,
      userPoints: null,
      tokenLimits: [],     // [{endpoint, limit_per_min}]
      activeSubs: [],      // [{id, plan_name, end_date, ...}]
      sdkSubs: [],
      featureSubs: [],
      showRefreshConfirm: false,
      tabIndex: this.computeInitialTab(),
      
      // 分享系统
      referralData: {
        invite_code: '',
        total_points: 0,
        points_today: 0,
        reward_points: 10
      },
      referralList: [],
      referralTotal: 0,
      referralPage: 1,
      referralPageSize: 10
    } 
  },
  computed: {
    inviteLink() {
      if (!this.referralData.invite_code) return '';
      const origin = window.location.origin;
      return `${origin}/login?invite_code=${this.referralData.invite_code}`;
    },
    shareLink() {
      const origin = window.location.origin;
      if (this.referralData.invite_code) {
        return `${origin}/me/profile?tab=2&invite_code=${this.referralData.invite_code}`;
      }
      return `${origin}/me/profile?tab=2`;
    },
    processedLimits() {
      const API_DEFINITIONS = {
        'daily': {
          name: 'daily',
          chineseName: '历史日线行情',
          desc: '获取指定股票的历史日线 K 线行情数据，支持前复权和后复权数据。'
        },
        'plates_rank': {
          name: 'plates_rank',
          chineseName: '获取全市场（题材/概念/行业）的热度排名',
          desc: '查询全市场所有题材、概念和行业板块的实时热度排名。'
        },
        'plates_rank_days': {
          name: 'plates_rank_days',
          chineseName: '板块top(区间排名)',
          desc: '查询板块类型在过去 N 天内的区间涨跌幅排名。'
        },
        'plates_rank_days_new': {
          name: 'plates_rank_days_new',
          chineseName: '板块top(区间排名+新进标记)',
          desc: '查询特定区间内板块的涨跌幅排名，并高亮标记近期新上榜的板块。'
        },
        'plates_stocks_rank': {
          name: 'market_plate_stocks',
          chineseName: '板块成分股人气排行',
          desc: '获取指定板块内的所有成分股票，并按全市场的人气值进行降序排列。'
        },
        'plate_popular_reason': {
          name: 'market_plate_popular_reason',
          chineseName: '板块爆发催化剂分析',
          desc: '获取题材板块爆发的每日核心催化剂、概念解读与涨停原因分析。'
        },
        'rt_k': {
          name: 'rt_k',
          chineseName: '实时行情日线快照',
          desc: '获取多只股票或匹配特定规则（如 3*.SZ）个股的最新实时分时与快照行情。'
        },
        'sentiment_timing': {
          name: 'sentiment_timing',
          chineseName: '小周期择时数据',
          desc: '小周期择时数据'
        },
        'stk_mins': {
          name: 'stk_mins',
          chineseName: '分钟数据(实时+历史)',
          desc: '分钟数据(实时+历史)'
        },
        'market_sentiment_kline': {
          name: 'market_sentiment_kline',
          chineseName: '市场情绪日K',
          desc: '综合全市场情绪数据量化出来的 K 线数据。'
        },
        'sentiment_market_hot_day': {
          name: 'sentiment_market_hot_day',
          chineseName: '市场情绪热度按天',
          desc: '按天查询全市场涨停家数、连板高度、赚钱效应及亏钱效应等核心热度指标。'
        },
        'sentiment_trend': {
          name: 'sentiment_trend',
          chineseName: '市场情绪分时趋势',
          desc: '按分钟/分时获取全市场情绪指数与成交额的分时变动趋势曲线。'
        },
        'review_uplimit_reason': {
          name: 'review_uplimit_reason',
          chineseName: '复盘-每日涨停原因',
          desc: '复盘每日涨停个股的封单金额、封单率、换手率以及爆发核心催化原因。'
        }
      };

      const map = {};
      this.tokenLimits.forEach(item => {
        const isIp = item.endpoint.endsWith('_ip');
        const baseKey = isIp ? item.endpoint.slice(0, -3) : item.endpoint;
        
        if (!map[baseKey]) {
          const def = API_DEFINITIONS[baseKey] || {
            name: baseKey,
            chineseName: item.chinese_name || baseKey,
            desc: item.description || '自定义数据接口'
          };
          map[baseKey] = {
            key: baseKey,
            name: def.name,
            chineseName: item.chinese_name || def.chineseName || baseKey,
            desc: def.desc,
            tokenLimit: '--',
            ipLimit: '--',
            description: item.description || ''
          };
        }
        
        if (isIp) {
          map[baseKey].ipLimit = `${item.limit_per_min} 次/分`;
        } else {
          map[baseKey].tokenLimit = `${item.limit_per_min} 次/分`;
        }
      });
      
      // Map to array and sort logically so it's clean
      const order = ['daily', 'rt_k', 'stk_mins', 'plates_rank', 'plates_stocks_rank', 'plates_rank_days', 'plates_rank_days_new', 'plate_popular_reason', 'market_sentiment_kline', 'sentiment_timing', 'sentiment_market_hot_day', 'sentiment_trend', 'review_uplimit_reason'];
      return Object.values(map).sort((a, b) => {
        const idxA = order.indexOf(a.key);
        const idxB = order.indexOf(b.key);
        if (idxA > -1 && idxB > -1) return idxA - idxB;
        if (idxA > -1) return -1;
        if (idxB > -1) return 1;
        return a.key.localeCompare(b.key);
      });
    }
  },
  watch: {
    '$route.query.tab'() {
      const idx = this.computeInitialTab();
      if (this.tabIndex !== idx) {
        this.tabIndex = idx;
      }
    },
    // 监听索引变化，实现数据实时刷新
    tabIndex(newVal) {
      if (newVal === 0) this.loadBasicInfo();
      if (newVal === 1) this.loadSubscriptions();
      if (newVal === 2) {
        this.loadToken();
        this.loadPoints();
      }
      if (newVal === 3) {
        this.loadReferralStats();
        this.loadReferralList();
      }

      // 同步 URL 参数，方便刷新后保持状态
      const currentTab = this.$route.query.tab;
      const targetQuery = newVal === 4 ? 'usage' : newVal;
      if (currentTab != targetQuery && parseInt(currentTab) !== newVal) {
        this.$router.replace({ query: { ...this.$route.query, tab: targetQuery } }).catch(() => {});
      }
    }
  },
  mounted(){ 
    this.load(); 
  },
  methods:{
    computeInitialTab() {
      const q = this.$route.query.tab;
      if (q === undefined || q === null) return 0;
      if (q === 'usage' || q === 'report' || q === 'api-usage') return 4;
      const n = parseInt(q);
      return isNaN(n) ? 0 : n;
    },
    load(){ 

      this.loadBasicInfo();
      this.loadToken();
      this.loadPoints();
      this.loadSubscriptions();
      this.loadReferralStats();
      this.loadReferralList();
    },
    loadBasicInfo() {
      request_zzquant({ url:'/v3/user/profile/me' }).then(res=>{ 
        const d=res.data&&res.data.data?res.data.data:{}; 
        this.user_nick=d.user_nick||''; 
        this.avatarUrl=d.avatar_url||this.full(d.avatar); 
        this.wx_name = d.wx_name || '';
        this.wx_avatar = d.wx_avatar || '';
        this.email = d.email || '';
      });
    },

    // ── Token ─────────────────────────────────────────────────
    loadToken() {
      request_zzquant({ url: '/v3/user/token' }).then(res => {
        const d = res.data && res.data.data ? res.data.data : {};
        this.apiToken = d.token || '';
      }).catch(() => {
        this.apiToken = '';
      });
    },

    async copyToken() {
      if (!this.apiToken) return;
      try {
        await navigator.clipboard.writeText(this.apiToken);
        this.tokenCopied = true;
        setTimeout(() => { this.tokenCopied = false; }, 2000);
      } catch (e) {
        // 降级方案（旧浏览器）
        const el = document.createElement('textarea');
        el.value = this.apiToken;
        document.body.appendChild(el);
        el.select();
        document.execCommand('copy');
        document.body.removeChild(el);
        this.tokenCopied = true;
        setTimeout(() => { this.tokenCopied = false; }, 2000);
      }
    },

    doRefreshToken() {
      request_zzquant({ url: '/v3/user/token/refresh', method: 'POST' }).then(res => {
        const d = res.data && res.data.data ? res.data.data : {};
        this.apiToken = d.token || '';
        this.tokenVisible = true;  // 刷新后短暂显示新 token
        this.msg = '✅ Token 已刷新，旧 Token 已立即失效';
        setTimeout(() => { this.tokenVisible = false; }, 5000);
      }).catch(err => {
        this.msg = '刷新失败：' + (err.message || '未知错误');
      });
    },
    
    async copyText(text) {
      try {
        await navigator.clipboard.writeText(text);
        this.msg = '✅ 已复制到剪贴板';
        setTimeout(() => { this.msg = ''; }, 2000);
      } catch (e) {
        this.msg = '复制失败';
      }
    },

    // ── Points + Limits ───────────────────────────────────────
    loadPoints() {
      request_zzquant({ url: '/v3/user/points' }).then(res => {
        const d = res.data && res.data.data ? res.data.data : {};
        this.userPoints = d.points !== undefined ? d.points : null;
        this.tokenLimits = d.limits || [];
      }).catch(() => {});
    },

    // ── Subscriptions ─────────────────────────────────────────
    loadSubscriptions() {
      request_zzquant({ url: '/v3/user/subscriptions' }).then(res => {
        const d = res.data && res.data.data ? res.data.data : {};
        this.sdkSubs = d.sdk_subscriptions || [];
        this.featureSubs = d.feature_subscriptions || [];
        this.activeSubs = d.subscriptions || [];
      }).catch(() => {});
    },

    // ── Referral Stats ─────────────────────────────────────────
    loadReferralStats() {
      request_zzquant({ url: '/v3/user/referral/stats' }).then(res => {
        if (res.data && res.data.code === 20000) {
          const d = res.data.data || {};
          this.referralData.invite_code = d.invite_code || '';
          this.referralData.total_points = d.total_points || 0;
          this.referralData.points_today = d.points_today || 0;
          this.referralData.reward_points = d.reward_points || 10;
          
          if (this.referralData.invite_code) {
            // Save to localStorage for share buttons to pick up easily
            localStorage.setItem('my_invite_code', this.referralData.invite_code);
            this.$nextTick(() => {
              this.generateQrCode();
            });
          }
        }
      }).catch(err => {
        console.error("加载推荐统计失败", err);
      });
    },
    
    loadReferralList() {
      request_zzquant({ 
        url: '/v3/user/referral/list',
        params: {
          page: this.referralPage,
          page_size: this.referralPageSize
        }
      }).then(res => {
        if (res.data && res.data.code === 20000) {
          this.referralList = res.data.data.items || [];
          this.referralTotal = res.data.data.total || 0;
        }
      }).catch(err => {
        console.error("加载邀请明细失败", err);
      });
    },
    
    changeReferralPage(p) {
      this.referralPage = p;
      this.loadReferralList();
    },

    async generateQrCode() {
      const container = document.getElementById('invite-qrcode');
      if (!container) return;
      container.innerHTML = '';
      
      try {
        const canvas = document.createElement('canvas');
        container.appendChild(canvas);
        await QRCode.toCanvas(canvas, this.inviteLink, {
          width: 150,
          margin: 2,
          color: {
            dark: '#000000',
            light: '#ffffff'
          }
        });
      } catch (err) {
        console.error('生成邀请二维码失败', err);
        container.innerHTML = '<div class="text-muted p-2">二维码生成失败</div>';
      }
    },

    // ── Password / Avatar ─────────────────────────────────────
    uploadAvatar(){ if(!this.file) return; const form=new FormData(); form.append('file',this.file); request_zzquant({ url:'/v3/user/profile/avatar/upload', method:'POST', data:form, headers:{ 'Content-Type':'multipart/form-data' } }).then(res=>{ const url=res.data&&res.data.data?res.data.data.url:null; if(url){ this.avatarUrl=url; this.file=null; try{ const raw=localStorage.getItem('user_info'); const info=raw?JSON.parse(raw):{}; info.avatar_url=url; localStorage.setItem('user_info', JSON.stringify(info)); window.dispatchEvent(new CustomEvent('user-login', { detail: { userInfo: info } })); }catch(e){ this.msg = '头像已更新，但本地信息刷新失败'; } } }) },
    save(){ 
      if(!this.new_password1||!this.new_password2){ 
        this.msg='请输入新密码'; 
        return 
      } 
      request_zzquant({ 
        url:'/v3/user/profile/password', 
        method:'POST', 
        data:{ 
          old_password:this.old_password, 
          new_password1:this.new_password1, 
          new_password2:this.new_password2 
        } 
      }).then(()=>{ 
        this.msg='密码已更新'; 
        this.old_password=''; 
        this.new_password1=''; 
        this.new_password2=''; 
      }).catch(err => {
        this.msg = err.response && err.response.data && err.response.data.msg ? err.response.data.msg : (err.message || '密码修改失败');
      }) 
    },
    full(u){ if(!u) return ''; if(u.startsWith('http')) return u; return 'https://api.zizizaizai.com'+u },
    
    showBindModal() {
      this.showWxModal = true;
    },
    onModalShown() {
      if (!this.wechatQrInited) {
        this.initWeChatQr();
      }
    },
    async initWeChatQr() {
      try {
        await this.loadWxLoginScript()
        const appid = process.env.VUE_APP_WECHAT_QR_APPID || 'wx45ac2ee1309c6e44'
        const origin = process.env.VUE_APP_WECHAT_REDIRECT_ORIGIN || window.location.origin
        const redirectPath = '/login/wx/bind/callback'
        const redirectUri = encodeURIComponent(`${origin}${redirectPath}`)
        
        /* global WxLogin */
        new WxLogin({
          id: 'wx-qrcode',
          appid,
          scope: 'snsapi_login',
          redirect_uri: redirectUri,
          state: 'bind',
          style: 'black',
          href: ''
        })
        this.wechatQrInited = true
      } catch (e) {
        console.error('初始化微信二维码失败', e)
        this.msg = '加载微信二维码失败，请稍后重试'
      }
    },
    loadWxLoginScript() {
      return new Promise((resolve, reject) => {
        if (window.WxLogin) {
          resolve()
        } else {
          const script = document.createElement('script')
          script.type = 'text/javascript'
          script.src = 'https://res.wx.qq.com/connect/zh_CN/htmledition/js/wxLogin.js'
          script.onload = () => resolve()
          script.onerror = () => reject()
          document.head.appendChild(script)
        }
      })
    },
    showEmailBindModal() {
        this.inputEmail = '';
        this.verificationCode = '';
        this.showEmailModal = true;
    },
    sendVerificationCode() {
        if (!this.inputEmail) {
            this.msg = '请输入邮箱地址';
            return;
        }
        if (this.inputEmail.indexOf('@') === -1 || this.inputEmail.indexOf('.') === -1) {
            this.msg = '邮箱格式不正确';
            return;
        }
        
        request_zzquant({
            url: '/v3/user/profile/email/code',
            method: 'POST',
            data: { email: this.inputEmail }
        }).then(res => {
            const msg = res.data && res.data.data ? res.data.data : '验证码已发送';
            this.msg = msg;
            
            this.countdown = 60;
            this.timer = setInterval(() => {
                this.countdown--;
                if (this.countdown <= 0) {
                    clearInterval(this.timer);
                    this.timer = null;
                }
            }, 1000);
        }).catch(err => {
             const errorMsg = err.response && err.response.data && err.response.data.msg ? err.response.data.msg : (err.message || '发送失败');
             this.msg = errorMsg;
        });
    },
    bindEmail(bvModalEvt) {
        bvModalEvt.preventDefault();
        if (!this.inputEmail) {
            this.msg = '请输入邮箱地址';
            return;
        }
        if (!this.verificationCode) {
            this.msg = '请输入验证码';
            return;
        }
        
        request_zzquant({
            url: '/v3/user/profile/email/bind',
            method: 'POST',
            data: { 
                email: this.inputEmail,
                code: this.verificationCode
            }
        }).then(() => {
            this.msg = '邮箱绑定成功';
            this.email = this.inputEmail;
            this.showEmailModal = false;
        }).catch(err => {
             const errorMsg = err.response && err.response.data && err.response.data.msg ? err.response.data.msg : (err.message || '绑定失败');
             this.msg = errorMsg;
        });
    },
    async logout() {
      const current = this.$router.currentRoute && this.$router.currentRoute.fullPath ? this.$router.currentRoute.fullPath : '/'
      try {
        await request_zzquant({ url: '/v3/auth/logout', method: 'post' })
      } catch (e) {
        console.warn('logout api failed', e)
      } finally {
        try {
          localStorage.removeItem('token')
          localStorage.removeItem('refresh_token')
          localStorage.removeItem('user_info')
        } catch (e) {
          console.warn('clear auth failed', e)
        }
        window.dispatchEvent(new CustomEvent('user-logout'))
        this.$router.push({ path: '/login', query: { redirect: current } })
      }
    }
  }
}
</script>

<style scoped>
.profile-container {
  max-width: 1000px;
}

/* Tabs 样式定制 */
::v-deep .nav-pills .nav-link {
  border-radius: 0;
  padding: 1.2rem 1.5rem;
  color: var(--text-muted);
  font-weight: 500;
  transition: all 0.2s;
  border-left: 3px solid transparent;
  background: transparent;
}

::v-deep .nav-pills .nav-link.active {
  background-color: var(--bg-card) !important;
  color: var(--accent-color) !important;
  border-left: 3px solid var(--accent-color);
}

::v-deep .nav-pills .nav-link:hover:not(.active) {
  background-color: var(--bg-muted);
  color: var(--text-main);
}

/* 卡片样式 */
.hover-shadow:hover {
  box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15) !important;
  transform: translateY(-2px);
}

.transition-all {
  transition: all 0.3s ease;
}

/* Token 文本 */
.token-input {
  font-family: 'SFMono-Regular', Consolas, 'Liberation Mono', Menlo, monospace;
  letter-spacing: 0.5px;
}

.token-input:focus {
  background-color: transparent !important;
}

.x-small {
  font-size: 0.75rem;
}

.tab-header h4 {
  color: var(--text-main);
  letter-spacing: -0.5px;
}

/* 适配深色模式下的背景 */
.bg-light {
  background-color: var(--bg-muted) !important;
}

.bg-white {
  background-color: var(--bg-card) !important;
}

.border {
  border-color: var(--border-color) !important;
}

/* 移动端适配 */
@media (max-width: 768px) {
  ::v-deep .nav-wrapper-class {
    border-right: none !important;
    border-bottom: 1px solid var(--border-color);
  }
  
  ::v-deep .nav-pills .nav-link {
    border-left: none;
    border-bottom: 3px solid transparent;
    padding: 0.8rem 1rem;
  }
  
  ::v-deep .nav-pills .nav-link.active {
    border-left: none;
    border-bottom: 3px solid var(--accent-color);
  }
}

.badge-info-soft {
  background-color: rgba(23, 162, 184, 0.1);
  color: #17a2b8;
  border: 1px solid rgba(23, 162, 184, 0.2);
  padding: 3px 6px;
  border-radius: 4px;
}

.api-link {
  text-decoration: none !important;
}

.api-link:hover code {
  text-decoration: underline !important;
}

body.theme-dark .badge-info-soft {
  background-color: rgba(34, 211, 238, 0.15);
  color: #22d3ee;
  border-color: rgba(34, 211, 238, 0.25);
}

.custom-limits-table th {
  border-bottom: 2px solid var(--border-color) !important;
  font-size: 0.85rem;
  letter-spacing: 0.5px;
  text-transform: uppercase;
}

.custom-limits-table td {
  vertical-align: middle !important;
}

.small-description {
  font-size: 0.85rem;
  line-height: 1.5;
  color: var(--text-muted);
}
</style>

